/**
 * Entrar a TORA. El formulario vive en `components/sesion/FormularioLogin`;
 * aca solo se decide a donde mandar a quien llega y a quien entra.
 *
 * Es una pantalla sin shell (`fixed inset-0`): no hay sidebar ni header hasta
 * que haya sesion, y el overlay tapa lo que el router haya alcanzado a pintar.
 */
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { LogoManzana } from "@/components/Logo";
import { PageHeader } from "@/components/layout/PageHeader";
import { FormularioLogin } from "@/components/sesion/FormularioLogin";
import { useAuth } from "@/lib/auth-context";

export const Route = createFileRoute("/login")({ component: Login });

function Login(): JSX.Element {
  const { autenticado, cargando, instalado, login, operando } = useAuth();
  const navegar = useNavigate();

  // Un login en una base sin usuarios no puede funcionar con ninguna
  // credencial: el camino es crear el primero.
  useEffect(() => {
    if (cargando) return;
    if (!instalado) void navegar({ to: "/instalar", replace: true });
    else if (autenticado) void navegar({ to: "/", replace: true });
  }, [cargando, instalado, autenticado, navegar]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto bg-background p-4">
      <div className="w-full max-w-sm space-y-6 py-8">
        <div className="flex flex-col items-center gap-3 text-center">
          <LogoManzana className="size-10 text-primary" />
          {/* El nombre UNA vez: antes iba repetido debajo en versalitas. */}
          <PageHeader
            titulo="MANZANA MORDIDA"
            linea={false}
            className="items-center text-center sm:items-center sm:justify-center"
          />
        </div>

        <FormularioLogin
          operando={operando}
          enviar={async (credenciales) => {
            await login(credenciales);
            await navegar({ to: "/", replace: true });
          }}
        />

        <p className="text-center text-xs text-muted-foreground">
          Si no te acordás la contraseña, pedile al administrador que te la cambie.
        </p>
      </div>
    </div>
  );
}
